import { gsap } from '../gsap/setup';
import SmoothScroll from '../singleton/SmoothScroll';

export default class Preloader {
  constructor({ onIntroComplete }) {
    this.$preloader = $('.preloader');
    this.$svg = this.$preloader.find('svg');
    this.onIntroComplete = onIntroComplete;

    this.timeline = gsap
      .timeline({
        delay: 0.5,
        onComplete: () => this.handleIntroComplete(),
      })
      .pause();
  }

  handleIntroComplete() {
    SmoothScroll.enableScrolling();
    SmoothScroll.scrollToTop({ immediate: true });
    this.onIntroComplete();
    this.hideAfterIntro();
  }

  hideAfterIntro() {
    if (!this.$preloader.length) {
      return;
    }

    gsap.to(this.$preloader[0], {
      opacity: 0,
      onComplete: () => {
        gsap.set(this.$preloader[0], {
          opacity: 1,
          x: '-100%',
          visibility: 'hidden',
        });

        gsap.set(this.$svg[0], {
          visibility: 'hidden',
        });
      },
    });
  }

  playIntro() {
    const $base = this.$preloader.find('.preloader__base');
    const $dots = this.$preloader.find('.preloader__dot');

    if (!$dots.length || !$base.length) {
      this.timeline.play();
      return;
    }

    this.timeline.fromTo(
      $base[0],
      {
        y: '60%',
        opacity: 0,
      },
      {
        duration: 0.75,
        y: 0,
        opacity: 1,
      },
    );

    $dots.each((key, dot) => {
      this.timeline
        .fromTo(
          dot,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.3,
          },
          '-=0.1',
        )
        .fromTo(
          dot,
          {
            y: '-115%',
          },
          {
            y: 0,
            duration: 0.4,
          },
          '-=0.15',
        );
    });

    this.timeline.play();
  }

  show() {
    gsap.set(this.$preloader[0], {
      visibility: 'visible',
    });

    return new Promise((resolve) => {
      gsap.to(this.$preloader[0], {
        x: '0',
        onComplete: () => resolve(),
      });
    });
  }

  hideAfterTransition() {
    gsap.to(this.$preloader[0], {
      x: '100%',
      onComplete: () => {
        gsap.set(this.$preloader[0], {
          x: '-100%',
          visibility: 'hidden',
        });
      },
    });
  }
}
